module.exports = __webpack_public_path__ + "static/media/nutrition.5fa66014.png";